import EditNotificationSettingForm from './EditNotificationSettingForm';

export default EditNotificationSettingForm;
